import Handler from "../Handler";

class TopupCancelHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processTopupCancel(receivedData);
  }
}

export default TopupCancelHandler;